/* eslint-disable import/prefer-default-export */
import React from "react";
import { AuthService } from "../services/AuthService";
import { AuthContext } from "../stores/AuthContext";

export const AuthProvider = ({ children }) => {
	const value = React.useMemo(() => {
		const authService = new AuthService({});
		return { authService };
	}, []);

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
